import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {postWindowParentMessage} from 'utils'
import {Button, Icon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${convertUnit(20)};
`

const StyledInfoContainer = styled.div`
  ${({theme}) => ({
    backgroundColor: theme.white_3,
  })}
  border-radius: ${convertUnit(8)};
  width: 100%;
  display: flex;
  gap: ${convertUnit(16)};
  align-items: center;
  box-sizing: border-box;
  padding: ${convertUnit(8)} ${convertUnit(16)};
  line-height: ${convertUnit(21)};
`

const StyledButton = styled(Button)`
  width: 100%;
`

export default function PaymentCheckoutStatusWaitingForPaymentInfo() {
  const {translate} = useTranslation()

  return (
    <StyledContainer>
      <StyledInfoContainer>
        <Icon type="info" size={16} />
        <div>
          <Paragraph lineHeight={21} fontWeight="medium">
            {translate('payment:statusWaitingReminder1')}
          </Paragraph>
          <Paragraph lineHeight={21} fontWeight="medium">
            {translate('payment:statusWaitingReminder2')}
          </Paragraph>
        </div>
      </StyledInfoContainer>
      <StyledButton
        label={translate('global:transactionHistory')}
        onClick={() => postWindowParentMessage({type: 'history'})}
      />
    </StyledContainer>
  )
}
